import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Target, Users, GraduationCap, Handshake, Trophy, Heart, ArrowRight, ExternalLink } from 'lucide-react';

const BigIkeRevival = () => {
  const alumniPhotos = [
    { src: 'https://static.wixstatic.com/media/eea016_c1c08a2f607845c18503215cc0e85616~mv2.jpg/v1/fill/w_996,h_379,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/EISENHOWER_FB_edited_edited.jpg', alt: 'Eisenhower Football' },
    { src: 'https://static.wixstatic.com/media/eea016_1d8107aff7084d819edf7f9b3e11c559~mv2.jpg/v1/fill/w_178,h_278,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/alexander_mister2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_61dfd96bc6d94806972906a3cda80b30~mv2.jpg/v1/fill/w_194,h_278,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/CLoston.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_385c7f21b35f4950998dff00ce9133d4~mv2.jpg/v1/fill/w_194,h_278,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_385c7f21b35f4950998dff00ce9133d4~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_9b99a054ac67469ebc74cab8a69bc967~mv2.jpg/v1/fill/w_178,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_9b99a054ac67469ebc74cab8a69bc967~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_bbe7c42cf91e466aa7c37f7616544722~mv2.jpg/v1/fill/w_208,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_bbe7c42cf91e466aa7c37f7616544722~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_e4d45215d5cb498683849f4936cb752d~mv2.png/v1/crop/x_0,y_0,w_210,h_236/fill/w_194,h_216,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_e4d45215d5cb498683849f4936cb752d~mv2.png', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_5c3a44949e744a4694f35cd1d0706c1f~mv2.jpg/v1/fill/w_194,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_5c3a44949e744a4694f35cd1d0706c1f~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_6cc4bd963c95470da30fa2a201ac12dd~mv2.webp/v1/fill/w_222,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_6cc4bd963c95470da30fa2a201ac12dd~mv2.webp', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_2e5eb5e06db54c7eac25adc64466207c~mv2.jpg/v1/crop/x_7,y_50,w_594,h_853/fill/w_178,h_238,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/RodD.jpg', alt: 'Rod D' },
  ];

  const alumniPhotos2 = [
    { src: 'https://static.wixstatic.com/media/eea016_6128d082fc3d4dcaafc77b3c5c0c49e4~mv2.jpg/v1/crop/x_253,y_293,w_1290,h_1278/fill/w_194,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_6128d082fc3d4dcaafc77b3c5c0c49e4~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_084ebb30f5804f4dada90cce86380539~mv2.webp/v1/fill/w_222,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_084ebb30f5804f4dada90cce86380539~mv2.webp', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_db174fb04b1d488eb74efd8dfbf1c0f5~mv2.jpg/v1/fill/w_178,h_192,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_db174fb04b1d488eb74efd8dfbf1c0f5~mv2.jpg', alt: 'Alumni' },
  ];

  const alumniPhotos3 = [
    { src: 'https://static.wixstatic.com/media/eea016_59a03fb78ae345e2bcde6223f2191926~mv2.jpg/v1/crop/x_12,y_32,w_380,h_414/fill/w_194,h_216,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_59a03fb78ae345e2bcde6223f2191926~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_33cdcacede704c6bb36ad2ac67a0d13b~mv2.jpg/v1/crop/x_40,y_34,w_220,h_239/fill/w_208,h_216,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_33cdcacede704c6bb36ad2ac67a0d13b~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_333aa2b66e3d45e6a637002c6ba91d70~mv2.jpg/v1/crop/x_267,y_0,w_834,h_869/fill/w_194,h_204,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_333aa2b66e3d45e6a637002c6ba91d70~mv2.jpg', alt: 'Alumni' },
  ];

  const alumniPhotos4 = [
    { src: 'https://static.wixstatic.com/media/eea016_fab55e13075b4b50bdf3c454494c6c9e~mv2.jpg/v1/fill/w_194,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Jaz%20R.jpg', alt: 'Jaz R' },
    { src: 'https://static.wixstatic.com/media/eea016_db623d3c6f164962949180b48e05ac8a~mv2.webp/v1/fill/w_208,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_db623d3c6f164962949180b48e05ac8a~mv2.webp', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_3bdbf427cc324075b069f1671c912e0e~mv2.jpg/v1/crop/x_262,y_43,w_279,h_364/fill/w_178,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/james%20jone.jpg', alt: 'James Jones' },
    { src: 'https://static.wixstatic.com/media/eea016_997de1d19a034dfd8b462a7598d0deb7~mv2.jpg/v1/crop/x_0,y_0,w_227,h_210/fill/w_238,h_216,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_997de1d19a034dfd8b462a7598d0deb7~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_9490d95285234a0890debdfd314cd7e0~mv2.jpg/v1/fill/w_178,h_234,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/eea016_9490d95285234a0890debdfd314cd7e0~mv2.jpg', alt: 'Alumni' },
    { src: 'https://static.wixstatic.com/media/eea016_bc5ad8d87bf14837bb851695ec45a988~mv2.jpeg/v1/fill/w_178,h_216,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Chubert.jpeg', alt: 'Chubert' },
  ];

  const programGoals = [
    { icon: Users, title: 'Reconnect Alumni', desc: 'Create a strong alumni network that mentors and supports current students.' },
    { icon: Trophy, title: 'Develop Athletes', desc: 'Provide professional-level development and position training through alumni, sports clubs, trainers, and nonprofit organizations that prioritize our youth.' },
    { icon: GraduationCap, title: 'Support Academics & Character', desc: 'Work with Eisenhower coaching staff to uphold high standards in the classroom and community, which will build each child\'s reputation, in turn, increasing their value and image in the long-term.' },
    { icon: Target, title: 'Create Opportunities', desc: 'Build pipelines for internships, scholarships, and career exposure through alumni connections.' },
    { icon: Handshake, title: 'Unite the Community', desc: 'Host events and initiatives that bring pride, and purpose back to Swoop Nation.' },
  ];

  const givingBack = [
    'Mentorship Provided by Professionals & Leadership Development',
    'We provide highly discounted Athletic Development & Sports Specific Training & Access to Sports Clubs that support our Aldine ISD community.',
    'Career Exposure, Internships, & Community Building Opportunities.',
    'Alumni-Led Community Events that intentionally recycle community dollars to provide more resources to our youth.',
  ];

  const missionPoints = [
    'Bring Purpose, Passion, Production, and Pride back to our community as a whole.',
    'Make the word SWOOP have a tangible meaning when spoken. As alumni we must support our youth directly if we want to establish a concrete future for the generations to come.',
    'To establish a strong alumni base who understand the power of group economics, and real unselfish support.',
    'Become a long standing and efficient resource to our youth, and their families. Increase scholarship opportunities.',
    'Bring value to the HISTORY & EXPERIENCES of productive members in the Swoop Nation by sharing their wisdom and experiences with our children.',
    'Provide Low cost service and over deliver. (Training, Mentorship, College Camp Visits, Summer Lunch Program, Nutrition Plans, & MORE...)',
    'Hold ourselves accountable first, while asking for help from those who live in our community or those who are of the Swoop Nation.',
    'Build an environment and a culture that is ATTRACTIVE to parents, students, alumni, college coaches, and commercial entities who want to invest in the SWOOP Brand.',
    'Provide our student-athletes with opportunities beyond sports.',
    'Make Big IKE a success factory.',
  ];

  const PhotoGrid = ({ photos, className = '' }) => (
    <div className={`flex flex-wrap justify-center gap-3 ${className}`}>
      {photos.map((photo, i) => (
        <img key={i} src={photo.src} alt={photo.alt} className="w-20 h-24 sm:w-24 sm:h-28 object-cover rounded-lg border-2 border-[#E6B933]/30 hover:border-[#E6B933] transition-all duration-300 hover:scale-105" />
      ))}
    </div>
  );

  return (
    <div className="min-h-screen pt-20" data-testid="big-ike-revival-page">
      {/* Hero Section */}
      <section className="relative bg-black overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.wixstatic.com/media/eea016_c1c08a2f607845c18503215cc0e85616~mv2.jpg/v1/fill/w_1920,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/EISENHOWER_FB_edited_edited.jpg"
            alt="Eisenhower Football"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/70" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-36 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white mb-6 tracking-tight" data-testid="big-ike-title">
            THE &nbsp;<span className="text-[#E6B933]">BIG IKE</span>&nbsp; REVIVAL
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto mb-4 leading-relaxed">
            Every dynasty has its ups and downs.
            The <span className="font-bold text-white">SWOOP NATION</span> has definitely been down lately,
            but with the support from <span className="text-[#E6B933] font-bold">THE BIG IKE ALUM</span>,
            new resources will be at the next generation of Eagles fingertips.
          </p>
          <p className="text-lg text-gray-200 mb-2 font-semibold">We will be dominant again....</p>
          <p className="text-base text-[#E6B933] italic max-w-2xl mx-auto mb-10 font-medium">
            IT'S PLAIN TO SEE...YOU CAN'T CHANGE ME...CUZ IMA BE AN EAGLE FOR LIFE!!! SWWWOOOOOP SWOOOOOOP!!!!
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/get-involved">
              <Button className="bg-[#E6B933] hover:bg-[#D4A01F] text-black font-bold px-8 py-3 text-base" data-testid="support-btn">
                Support This Initiative <Heart className="ml-2 w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* We Are Swoop Nation + Alumni Photos */}
      <section className="py-20 bg-zinc-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl sm:text-5xl font-black text-center text-white mb-8">
            WE ARE <span className="text-[#E6B933]">SWOOP NATION</span>
          </h2>
          <ul className="flex flex-wrap justify-center gap-x-8 gap-y-3 mb-12">
            {['Greatness Lives Here', 'Opportunity Lives Here', 'You Have The Potential', 'We Are Your Resource', 'From Your Alumni...We Are Here... Use Us!!!'].map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-gray-300 text-lg">
                <div className="w-2 h-2 rounded-full bg-[#E6B933] flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>

          {/* Alumni Photo Grid */}
          <PhotoGrid photos={alumniPhotos.slice(1)} />
        </div>
      </section>

      {/* Mission & Purpose */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="bg-zinc-900 border-zinc-800 p-8 md:p-10">
              <h3 className="text-2xl font-bold text-[#E6B933] mb-5">Our Mission</h3>
              <p className="text-gray-300 leading-relaxed text-base">
                The Big IKE Revival is a community-driven initiative powered by Aldine Eisenhower alumni, coaches, and supporters.
                Our mission is to bridge the gap between generations — connecting past, present, and future Eagles to restore pride, unity, and opportunity in our community.
              </p>
            </Card>
            <Card className="bg-zinc-900 border-zinc-800 p-8 md:p-10">
              <h3 className="text-2xl font-bold text-[#E6B933] mb-5">Our Purpose</h3>
              <p className="text-gray-300 leading-relaxed text-base">
                We're building a sustainable ecosystem that provides academic, athletic, mentorship, and economic resources for current Eisenhower students and athletes.
                By leveraging alumni experience and community partnerships, we're ensuring today's youth have access to opportunities we didn't know existed when we were their age.
              </p>
            </Card>
          </div>
        </div>
      </section>

      {/* Program Goals + Alumni Photos */}
      <section className="py-20 bg-zinc-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-white text-center mb-12">
            Program <span className="text-[#E6B933]">Goals</span>
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {programGoals.map((goal, i) => (
              <Card key={i} className="bg-zinc-900 border-zinc-800 p-6 hover:border-[#E6B933]/40 transition-all duration-300 group" data-testid={`program-goal-${i}`}>
                <div className="w-12 h-12 rounded-xl bg-[#E6B933]/10 flex items-center justify-center mb-4 group-hover:bg-[#E6B933]/20 transition-colors">
                  <goal.icon className="w-6 h-6 text-[#E6B933]" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{goal.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{goal.desc}</p>
              </Card>
            ))}
          </div>

          {/* More Alumni Photos */}
          <PhotoGrid photos={alumniPhotos2} />
        </div>
      </section>

      {/* How We Give Back + Alumni Photos */}
      <section className="py-20 bg-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold text-white mb-6">
                How We <span className="text-[#E6B933]">Give Back</span>
              </h2>
              <ul className="space-y-4">
                {givingBack.map((item, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <ArrowRight className="w-5 h-5 text-[#E6B933] mt-0.5 flex-shrink-0" />
                    <span className="text-gray-300">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <PhotoGrid photos={alumniPhotos3} />
            </div>
          </div>

          {/* Action Links */}
          <div className="flex flex-wrap gap-4 justify-center mb-12">
            <a href="https://www.wixforms.com/f/7418111759266874369" target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#E6B933] hover:bg-[#D4A01F] text-black font-bold px-6 py-3" data-testid="alumni-signup-btn">
                IKE Alumni Sign Up <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="https://www.wixforms.com/f/7377411625474589828" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-[#E6B933] text-[#E6B933] hover:bg-[#E6B933]/10 font-bold px-6 py-3" data-testid="register-child-btn">
                Register Your Child Here <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="https://www.missingelementsports.com/_files/ugd/eea016_53f7d5b3fbc0405caf7bcc7464fd8854.pdf" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-white/40 text-white hover:bg-white/10 font-bold px-6 py-3" data-testid="crawfish-fundraiser-btn">
                Crawfish Fundraiser <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
          </div>

          {/* More Alumni Photos */}
          <PhotoGrid photos={alumniPhotos4} />
        </div>
      </section>

      {/* 10-Point Plan */}
      <section className="py-20 bg-zinc-950">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-4">
            <p className="text-[#E6B933] text-sm font-bold tracking-widest uppercase mb-3">Swoop Nation Only</p>
          </div>

          {/* Community Image */}
          <div className="mb-12 rounded-2xl overflow-hidden">
            <img
              src="https://static.wixstatic.com/media/11062b_77bc831f356a48c4883112fcf1602a6a~mv2_d_4586_3057_s_4_2.jpg/v1/fill/w_960,h_460,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/11062b_77bc831f356a48c4883112fcf1602a6a~mv2_d_4586_3057_s_4_2.jpg"
              alt="Swoop Nation Community"
              className="w-full h-64 md:h-80 object-cover"
            />
          </div>

          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3">
              Connecting Eisenhower Eagles
            </h2>
            <p className="text-[#E6B933] text-lg font-semibold">Current &middot; Future &middot; Past</p>
            <p className="text-gray-400 mt-2 text-lg">Our Mission...Purpose...Plan:</p>
          </div>
          <div className="space-y-4">
            {missionPoints.map((point, i) => (
              <div key={i} className="flex gap-4 items-start bg-zinc-900/50 border border-zinc-800 rounded-xl p-5 hover:border-[#E6B933]/30 transition-all duration-300" data-testid={`mission-point-${i}`}>
                <span className="text-[#E6B933] font-black text-lg w-8 flex-shrink-0">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-gray-300 leading-relaxed">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Resources & CTA */}
      <section className="py-20 bg-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            SWOOP <span className="text-[#E6B933]">NATION</span> ONLY
          </h2>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
            Join the movement. Whether you're an alumni, parent, student, or community supporter — there's a place for you in the Big IKE Revival.
          </p>
          <div className="flex flex-wrap gap-4 justify-center mb-10">
            <a href="https://www.wixforms.com/f/7418111759266874369" target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#E6B933] hover:bg-[#D4A01F] text-black font-bold px-8 py-3" data-testid="cta-alumni-signup">
                IKE Alumni Sign Up <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="https://www.wixforms.com/f/7377411625474589828" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-[#E6B933] text-[#E6B933] hover:bg-[#E6B933]/10 font-bold px-8 py-3" data-testid="cta-register-child">
                Register Your Child <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="https://www.missingelementsports.com/_files/ugd/eea016_c656f588cad94909a62be53b6fd62c5c.pdf" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-white/40 text-white hover:bg-white/10 font-bold px-8 py-3" data-testid="cta-program-outline">
                Big Ike Revival Program Outline <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
            <a href="https://www.dragonsyouthtrackandfield.com/" target="_blank" rel="noopener noreferrer">
              <Button variant="outline" className="border-white/40 text-white hover:bg-white/10 font-bold px-8 py-3" data-testid="cta-dragons-track">
                Dragons Track & Field Club <ExternalLink className="ml-2 w-4 h-4" />
              </Button>
            </a>
          </div>
          <Link to="/get-involved">
            <Button variant="outline" className="border-[#E6B933] text-[#E6B933] hover:bg-[#E6B933]/10 font-bold px-10 py-3 text-base" data-testid="cta-get-involved-btn">
              Get Involved with WHY ME Foundation
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BigIkeRevival;
